<template>
  <div class="evaluate">
    <div class="evaluate-header">
      <el-tooltip :content="evaluateData.title" placement="top-end">
        <div class="evaluate-header-icon">{{ evaluateData.title }}</div>
      </el-tooltip>
      <div class="evaluate-header-department">{{ evaluateData.department }}</div>

    </div>

    <div class="evaluate-container-box">
      <div class="evaluate-container">
      <div class="evaluate-container-user">{{ evaluateData.user }}:</div>
      <div class="evaluate-containe-remark">“ {{ evaluateData.remark }} ”</div>
      <!-- Look: 待补充动态背景图 -->
      <div class="evaluate-header-star"  :style="{ 'background-image': `url(${getBGStar()})`}"></div>
      <div class="evaluate-container-timeline">{{ evaluateData.timeline }}</div>
    </div>
    </div>
  </div>
</template>
<script>
import level1 from '@/assets/front/evaluate-level1.png'
import level2 from '@/assets/front/evaluate-level2.png'
import level3 from '@/assets/front/evaluate-level3.png'
import level4 from '@/assets/front/evaluate-level4.png'
import level5 from '@/assets/front/evaluate-level5.png'

export default {
  props: {
    evaluateData: {
      default: () => {},
      type: Object,
    }
  },
  mounted() {
  },
  methods: {
    getBGStar() {
      const level = this.evaluateData.start
      let bg = null
      switch (level) {
        case 1:
          bg = level1
          break
        case 2:
          bg = level2
          break
        case 3:
          bg = level3
          break
        case 4:
          bg = level4
          break
        case 5:
          bg = level5
          break

        default:
          bg = level5
          break
      }
      console.log('bg', bg)
      return bg
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";
.evaluate {
  width: 100%;
  background-color: #fff;

  .evaluate-header {
    position: relative;
    .evaluate-header-icon {
      min-width: 105px;
      max-width: 201px;
      height: 24px;
      cursor: pointer;
      display: inline-block;
      vertical-align: bottom;
      background-color: rgba(60,110,240,0.1);
      border-radius: 12px;
      background-image: url('~@/assets/front/evaluate-icon.png');
      background-repeat: no-repeat;
      background-size: 20px;
      background-position: left 3px bottom 2px;
      padding-left: 28px;
      color: #3C6EF0;
      @include font-family-jd;
      font-size: 16px;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-wrap: nowrap;
      text-overflow: ellipsis;
    }
    .evaluate-header-department {
      margin-left: 8px;
      display: inline-block;
    }

  }

  .evaluate-container-box {
    background-image: url('~@/assets/front/dot.png');
    background-size: 10px;
    background-repeat: repeat-y;
    background-position: left 8px bottom -6px;
    padding: 12px 0 16px 28px;
    // margin:
  }
  .evaluate-header-star {
      width: 126px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 12px;
      display: inline-block;
      background-image: url('~@/assets/front/evaluate-level1.png');
      background-size: cover;
    }
  .evaluate-container {
    min-height: 100px;
    width: 538px;
    background: linear-gradient(225deg, rgba(239,246,255,1) 0%,rgba(247,249,255,1) 100%);
    border-radius: 0 16px 16px 16px;

    box-sizing: border-box;
    padding: 16px;
    position: relative;

    .evaluate-container-user {
      color: #525765;
      font-size: 13px;
      line-height: 12px;
      position: absolute;
      top: 16px;
    }
    .evaluate-containe-remark {
      display: inline-block;
      color: #23252B;
      font-size: 14px;
      line-height: 18px;
      margin-top: 24px;
      margin-bottom: 18px;
    }
    .evaluate-container-timeline {
      color: #868D9F;
      font-size: 12px;
      position: absolute;
      bottom: 12px;
      position: absolute;
      right: 16px;
      bottom: 16px;
    }
  }
}
</style>
